import React from "react";
import Avatar from "@mui/material/Avatar";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

function Cards(props) {

    
    return (
         props.showLoader ? <div className="grid grid-cols-12 gap-x-6 gap-y-9 w-[1030px]">
            {
                [...Array(2)].map((e , index) => ( 
                    <div key={index} className="shadow-omd rounded-md grid grid-cols-12 gap-3 col-span-12 md:col-span-6 bg-white-1 mx-3 md:mx-0 px-6 md:px-12 py-6 md:py-10">
                        <div className="col-span-12 flex items-center justify-between" >
                            <Skeleton height={40} width={100} />
                            <Skeleton height={50} width={50} circle/>
                        </div>
                        <div className="col-span-12 mt-3">
                            <Skeleton height={30} width={150} />
                        </div>
                        <div className="col-span-12 flex mt-2 space-x-8 ml-3">
                            <Skeleton height={60} width={60} circle/>
                            <Skeleton height={60} width={60} circle/>
                            <Skeleton height={60} width={60} circle/>
                            <Skeleton height={60} width={60} circle className="hidden md:flex"/>
                        </div>
                        <div className="col-span-12 flex mt-1 space-x-4">
                            <Skeleton height={30} width={85} />
                            <Skeleton height={30} width={80} />
                            <Skeleton height={30} width={80} />
                            <Skeleton height={30} width={80} className="hidden md:flex"/>
                        </div>
                        <div className="col-span-12 mt-3">
                            <Skeleton height={40} width={170} />
                        </div>
                    </div>
             ) ) } </div>      
        : 
        <div className="grid grid-cols-12 gap-x-6 gap-y-9 w-[1030px]">
            {
                props.boards.map( (board,index) =>
                    <div key={index} className="col-span-12 md:col-span-6 flex flex-col items-center rounded-md shadow-omd mx-3 md:mx-0 bg-white-1 " >
                        <div className="bg-[#006BFF] h-2 w-full rounded-t-md "></div>
                        <div className="col-span-12 grid grid-cols-12 gap-3 flex flex-col items-start justify-start w-full gap-6 px-6 md:px-12 py-6 md:py-10 rounded-b-md">
                            <div className="col-span-12 flex items-center justify-between w-full">
                                <h3 className="text-2xl font-semibold">{board.title}</h3>
                                <Avatar className="bg-[#0B5FFF] p-3 cursor-pointer ml-2" sx={{ width: 48, height: 48 }} src="/addPerson.svg" onClick={()=>props.handleOpen(board.id)} />
                            </div>
                            <div className="col-span-12 flex flex-col items-start justify-start gap-7 cursor-pointer" onClick={() => props.toEditBoard(board.id, board.title)}>
                                <h3 className="text-base font-semibold">Candidates:</h3>
                                {/* For small screens */}
                                {/* Profiles added in board */}
                                <div className="md:hidden">
                                {
                                    board.candidates.length > 0 ? <div className="flex justify-start w-full gap-x-3 gap-y-5 ">
                                    {board.candidates.slice(0,2)
                                    .map( (candidate,i) =>
                                        <div key={i} className="flex flex-col items-center justify-center gap-5 cursor-pointer">
                                            <div style={{backgroundColor: candidate.bg_color}} className=" p-3 rounded-full" ><Avatar src={candidate.emoji_url} imgProps={ {'style':{'objectFit': 'contain'}}} /></div>
                                            <div className="border-[1px] px-2 py-1 rounded-sm border-[#c8e1f0] font-medium text-sm w-24 text-center" >{candidate.full_name?.split(" ")[0]}</div>
                                        </div>
                                    )}
                                    { (board.candidates.length > 2) && <div className="flex flex-col items-center justify-center gap-3 cursor-pointer">
                                            <div className="bg-[#FFE7E7] p-3 rounded-full mb-1" ><Avatar src="user1.svg" imgProps={ {'style':{'objectFit': 'contain'}}} /></div>
                                            <div className="border-[1px] px-2 py-1 rounded-sm border-[#c8e1f0] font-medium text-sm w-24  mt-1" >+ {board.candidates.length - 2} more</div>
                                        </div>
                                    }
                                </div> : 
                                    // No profile in board
                                    <div className="">
                                        <img  src="noprofile.png" />
                                        <div className="rounded-sm font-medium text-sm text-center pt-7" >No candidates added in this board yet.</div>
                                    </div>
                                }
                                </div>

                                {/* For large screens */}
                                <div className="hidden md:flex">
                                {
                                    board.candidates.length > 0 ? <div className="flex justify-start w-full gap-x-3 gap-y-5 min-w-[340px]">
                                    {board.candidates.slice(0,3)
                                    .map( (candidate,i) =>
                                        <div key={i} className="flex flex-col items-center justify-center gap-5 cursor-pointer">
                                            <div style={{backgroundColor: candidate.bg_color}} className=" p-3 rounded-full" ><Avatar src={candidate.emoji_url} imgProps={ {'style':{'objectFit': 'contain'}}} /></div>
                                            <div className="border-[1px] px-2 py-1 rounded-sm border-[#c8e1f0] font-medium text-sm w-24 text-center" >{candidate.full_name?.split(" ")[0]}</div>
                                        </div>
                                    )}
                                    { (board.candidates.length > 3) && <div className="flex flex-col items-center justify-center gap-3 cursor-pointer">
                                            <div className="bg-[#FFE7E7] p-3 rounded-full mb-1" ><Avatar src="user1.svg" imgProps={ {'style':{'objectFit': 'contain'}}} /></div>
                                            <div className="border-[1px] px-2 py-1 rounded-sm border-[#c8e1f0] font-medium text-sm w-24  mt-1" >+ {board.candidates.length - 3} more</div>
                                        </div>
                                    }
                                </div> : 
                                    // No profile in board
                                    <div className="">
                                        <img  src="noprofile.png" />
                                        <div className="rounded-sm font-medium text-sm text-center pt-7" >No candidates added in this board yet.</div>
                                    </div>
                                }
                                </div>

                                <button className={`bg-[#0F69F6] px-12 py-2 rounded-md text-white-1 font-semibold text-sm ${board?.candidates?.length <= 0 ? "mt-2" : ""}`} onClick={() => props.toEditBoard(board.id, board.title)}>Edit Board</button>
                            </div>
                        </div>
                    </div>
                )
            } 
        </div>
    )
}

export default Cards